import { useId } from "react";

export const DiamondMark = ({ size = 34 }) => {
  const gid = useId().replace(/[^a-zA-Z0-9]/g, "");
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F2F2F7" />
          <stop offset="0.5" stopColor="#8E8E93" />
          <stop offset="1" stopColor="#1C1C1E" />
        </linearGradient>
      </defs>
      <path
        d="M50 6 L92 40 L50 94 L8 40 Z"
        fill={`url(#${gid})`}
        stroke="#F2F2F7"
        strokeWidth="1.5"
      />
      <path d="M50 6 L68 40 L50 94 L32 40 Z" fill="#050505" opacity="0.35" />
      <path d="M8 40 L92 40" stroke="#F2F2F7" strokeWidth="1" opacity="0.6" />
      <path
        d="M32 40 L50 6 L68 40"
        stroke="#F2F2F7"
        strokeWidth="0.8"
        opacity="0.5"
        fill="none"
      />
    </svg>
  );
};

export const Grain = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-50 opacity-[0.055] mix-blend-screen"
    style={{
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
    }}
  />
);

export const MonoLabel = ({ children, className = "", ...props }) => (
  <span
    className={`font-mono text-[11px] uppercase tracking-[0.28em] text-[#8E8E93] ${className}`}
    {...props}
  >
    {children}
  </span>
);
